/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router';

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as IndexImport } from './routes/index';
import { Route as VariablesIndexImport } from './routes/variables/index';

// Create Virtual Routes

const VariablesVariableNameRolloutLazyImport = createFileRoute(
  '/variables/$variableName/rollout',
)();

// Create/Update Routes

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route));

const VariablesIndexRoute = VariablesIndexImport.update({
  path: '/variables/',
  getParentRoute: () => rootRoute,
} as any);

const VariablesVariableNameRolloutLazyRoute =
  VariablesVariableNameRolloutLazyImport.update({
    path: '/variables/$variableName/rollout',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/variables/$variableName/rollout.lazy').then(
      (d) => d.Route,
    ),
  );

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/variables/': {
      id: '/variables/';
      path: '/variables';
      fullPath: '/variables';
      preLoaderRoute: typeof VariablesIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/variables/$variableName/rollout': {
      id: '/variables/$variableName/rollout';
      path: '/variables/$variableName/rollout';
      fullPath: '/variables/$variableName/rollout';
      preLoaderRoute: typeof VariablesVariableNameRolloutLazyImport;
      parentRoute: typeof rootRoute;
    };
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/variables': typeof VariablesIndexRoute;
  '/variables/$variableName/rollout': typeof VariablesVariableNameRolloutLazyRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/variables': typeof VariablesIndexRoute;
  '/variables/$variableName/rollout': typeof VariablesVariableNameRolloutLazyRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/variables/': typeof VariablesIndexRoute;
  '/variables/$variableName/rollout': typeof VariablesVariableNameRolloutLazyRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths: '/' | '/variables' | '/variables/$variableName/rollout';
  fileRoutesByTo: FileRoutesByTo;
  to: '/' | '/variables' | '/variables/$variableName/rollout';
  id: '__root__' | '/' | '/variables/' | '/variables/$variableName/rollout';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  VariablesIndexRoute: typeof VariablesIndexRoute;
  VariablesVariableNameRolloutLazyRoute: typeof VariablesVariableNameRolloutLazyRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  VariablesIndexRoute: VariablesIndexRoute,
  VariablesVariableNameRolloutLazyRoute: VariablesVariableNameRolloutLazyRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/variables/",
        "/variables/$variableName/rollout"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/variables/": {
      "filePath": "variables/index.tsx"
    },
    "/variables/$variableName/rollout": {
      "filePath": "variables/$variableName/rollout.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
